import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import {
  validaSoloNumero,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  validaNumeroTelefono,
  validaEmail,
} from "../../util/varios";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import moment from "moment";
import axios from "axios";

/* import CatalogoPersona from '../../catalogos/catalogoPersona';
import CatalogoAgente from '../../catalogos/catalogoAgente'; */
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import CatalogoOrganizacion from "../../catalogos/catalogoOrganizacion";

const ModalActualizarUsuario = (props) => {
  const [clase, setClase] = useState("d-flex bluex-bg");
  let idusuario = JSON.parse(localStorage.getItem("idusuario"));

  const chkPerCon = useRef();
  const chkPerIn = useRef();
  const chkPerMod = useRef();
  const chkPerEli = useRef();
  const chkPerTodo = useRef();

  const chkUserCon = useRef();
  const chkUserIn = useRef();
  const chkUserMod = useRef();
  const chkUserEli = useRef();
  const chkUserTodo = useRef();

  const chkEsOrCon = useRef();
  const chkEsOrIn = useRef();
  const chkEsOrMod = useRef();
  const chkEsOrEli = useRef();
  const chkEsOrTodo = useRef();

  const chkUteCon = useRef();
  const chkUteIn = useRef();
  const chkUteMod = useRef();
  const chkUteEli = useRef();
  const chkUteTodo = useRef();

  const chkPorCon = useRef();
  const chkPorIn = useRef();
  const chkPorMod = useRef();
  const chkPorEli = useRef();
  const chkPorTodo = useRef();

  const chkUWebCon = useRef();
  const chkUWebIn = useRef();
  const chkUWebMod = useRef();
  const chkUWebEli = useRef();
  const chkUWebTodo = useRef();

  const chkUAppCon = useRef();
  const chkUAppIn = useRef();
  const chkUAppMod = useRef();
  const chkUAppEli = useRef();
  const chkUAppTodo = useRef();

  const chkOrgCon = useRef();
  const chkOrgIn = useRef();
  const chkOrgMod = useRef();
  const chkOrgEli = useRef();
  const chkOrgTodo = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnEnviar = useRef();
  const [itemAccaplicaciones, setItemAccaplicaciones] = useState();
  const [itemAccconfigene, setItemAccconfigene] = useState();
  const [itemAccpersonas, setItemAccpersonas] = useState();
  const [itemAccusertim, setItemAccusertim] = useState();
  const [mostrarPersona, setMostrarPersona] = useState(false);
  const [mostrarOrg, setMostrarOrg] = useState(false);
  const [itemAccuc, setItemAccuc] = useState();
  const [itemAccute, setItemAccute] = useState();
  const [itemAccporcenute, setItemAccporcenute] = useState();
  const [itemAccuserweb, setItemAccuserweb] = useState();
  const [itemAccuserapp, setItemAccuserapp] = useState();
  const [itemAccestorg, setitemAccestorg] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [body, setBody] = useState({});
  const [mostrar4, setMostrar4] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [contar, setContar] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [password, setPassword] = useState("");
  const [activate, setActivate] = useState(false);
  const [usuario, setUsuario] = useState();
  const [persona, setPersona] = useState({
    cedula: "",
    nombres: "",
    apellidos: "",
    direccion: "",
    correoe: "",
    tlf1: "",
    tlf2: "",
    fnacimiento: "",
    nacionalidad: "",
    sexo: "",
  });
  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarClave1, setMostrarClave1] = useState(false);
  const [correo, setCorreo] = useState("");
  const [modulos, setModulos] = useState({
    permodtimbre: "0",
    permodminas: "0",
    permod1x500: "0",
    permodprod: "0",
    permodfiscal: "0",
    permodingresos: "0",
    permodpresu: "0",
    permodconfig: "0",
  });

  const [acciones, setAcciones] = useState({
    org1: "",
    org2: "",
    org3: "",
    org4: "",
    estru1: "",
    estru2: "",
    estru3: "",
    estru4: "",
    user1: "",
    user2: "",
    user3: "",
    user4: "",
    person1: "",
    person2: "",
    person3: "",
    person4: "",
  });
  const [permisos, setPermisos] = useState({
    acccontribuyente: "0000",
    accactividad: "0000",
    accdeclaraciones: "000",
    accacticontri: "00",
    accagente: "0000",
    accusuariocome: "0000",
  });

  const [url, setUrl] = useState("");

  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tecla, setTecla] = useState();
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndex1, setTabIndex1] = useState(0);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const txtIdUsuario = useRef();
  const txtLogin = useRef();
  const txtPassword = useRef();
  const txtConfirmPassword = useRef();
  const txtIdOrg = useRef();
  const txtNombreOrg = useRef();
  const txtCedula = useRef();
  const txtNombreUsuario = useRef();
  const txtApellidoUsuario = useRef();
  const txtDireccionUsuario = useRef();
  const txtEmailUsuario = useRef();
  const txtTlfUsuario = useRef();
  const txtCelUsuario = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const cmbStatus = useRef();
  const [aplicaciones, setAplicaciones] = useState({
    contabilidadpresus: "0",
    administracion: "0",
    ingenieriamun: "0",
    contabilidadfis: "0",
    compraventa: "0",
    bienesmunicipales: "0",
    gestioncontrol: "0",
    rentasmuni: "0",
    catastro: "0",
    nomina: "0",
  });

  const [aplicaciones2, setAplicaciones2] = useState({
    iva: "0",
    ut: "0",
    ta: "0",
    tp: "0",
    cfecha: "0",
    cefiscal: "0",
  });

  console.log(
    aplicaciones.contabilidadpresus +
      aplicaciones.administracion +
      aplicaciones.ingenieriamun +
      aplicaciones.contabilidadfis +
      aplicaciones.compraventa +
      aplicaciones.bienesmunicipales +
      aplicaciones.gestioncontrol +
      aplicaciones.rentasmuni +
      aplicaciones.catastro +
      aplicaciones.nomina,
  );

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (props.operacion) {
      setOperacion(props.operacion);
    }

    if (op.reportes != null) {
      setUrl(op.reportes.trim());
    } else {
      setUrl("");
    }
  }, [props.operacion]);

  const procesarRegistro = () => {
    let endpoint = `${op.conexion}/api/configuracion/actualizaruser`;

    console.log(
      "------------------------ body -------------------------------",
    );
    console.log(body);
    console.log(
      "------------------------ body -------------------------------",
    );

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          props.onHideRender();

          setActivate(false);

          var mensaje = "";
          if (operacion === 1) {
            mensaje = "El usuario ha sido registrada de manera satisfactoria.";
          } else if (operacion === 2) {
            mensaje = "El usuario ha sido modificada de manera satisfactoria.";
          } else if (operacion === 3) {
            mensaje = "El usuario ha sido eliminada de manera satisfactoria.";
          }

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: mensaje,
            icono: "exito",
          });
          setActivate(false);
          blanquear();

          console.log(idusuario, parseInt(props.usuario.idusuario));

          if (parseInt(idusuario) === parseInt(props.usuario.idusuario)) {
            localStorage.setItem(
              "accaplicacion",
              JSON.stringify(
                aplicaciones.contabilidadpresus +
                  aplicaciones.administracion +
                  aplicaciones.ingenieriamun +
                  aplicaciones.contabilidadfis +
                  aplicaciones.compraventa +
                  aplicaciones.bienesmunicipales +
                  aplicaciones.rentasmuni +
                  aplicaciones.catastro +
                  aplicaciones.nomina +
                  aplicaciones.gestioncontrol ,
              ),
            );

            localStorage.setItem(
              "accestructura",
              JSON.stringify(
                acciones.estru1 +
                  acciones.estru2 +
                  acciones.estru3 +
                  acciones.estru4,
              ),
            );
            localStorage.setItem(
              "accorganizacion",
              JSON.stringify(
                acciones.org1 + acciones.org2 + acciones.org3 + acciones.org4,
              ),
            );
            localStorage.setItem(
              "accusuario",
              JSON.stringify(
                acciones.user1 +
                  acciones.user2 +
                  acciones.user3 +
                  acciones.user4,
              ),
            );
            localStorage.setItem(
              "accpersona",
              JSON.stringify(
                acciones.person1 +
                  acciones.person2 +
                  acciones.person3 +
                  acciones.person4,
              ),
            );

            localStorage.setItem("acciva", JSON.stringify(aplicaciones2.iva));
            localStorage.setItem("accut", JSON.stringify(aplicaciones2.ut));
            localStorage.setItem(
              "acctasaactiva",
              JSON.stringify(aplicaciones2.ta),
            );
            localStorage.setItem(
              "acctasapasiva",
              JSON.stringify(aplicaciones2.tp),
            );
            localStorage.setItem(
              "acccambiofecha",
              JSON.stringify(aplicaciones2.cfecha),
            );
            localStorage.setItem(
              "acccambioefiscal",
              JSON.stringify(aplicaciones2.cefiscal),
            );
            //window.location.reload();
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.ingresa === 0) {
            txtNombreUsuario.current.value = "";
            txtApellidoUsuario.current.value = "";
            txtDireccionUsuario.current.value = "";
            txtEmailUsuario.current.value = "";
            txtTlfUsuario.current.value = "";
            txtCelUsuario.current.value = "";
            txtFechaNac.current.value = "";
            cmbNacionalidad.current.value = "V";
            cmbSexo.current.value = "M";
          }

          setHabilitadoNU(true);

          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNombreUsuario.current.value = response.data.nombres;
            txtApellidoUsuario.current.value = response.data.apellidos;
            txtDireccionUsuario.current.value = response.data.direccion;
            txtEmailUsuario.current.value = response.data.correoe;
            txtTlfUsuario.current.value = response.data.tlf1;
            txtCelUsuario.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment
              .utc(response.data.fnacimiento)
              .format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              setTabIndex(1);
              setTabIndex1(0);
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreUsuario.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleCloseCatalogoAge = () => {
    setMostrar4(false);
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer,
  ) => {
    setMostrar3(false);
    txtCedula.current.value = cedPer;
    txtNombreUsuario.current.value = nomPer;
    txtApellidoUsuario.current.value = apePer;
    txtDireccionUsuario.current.value = direPer;
    txtEmailUsuario.current.value = correoPer;
    txtTlfUsuario.current.value = tlf1Per;
    txtCelUsuario.current.value = tlf2Per;
    txtFechaNac.current.value = moment.utc(fnacPer).format("YYYY-MM-DD");
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer;
    btnAcepta.current.focus();
  };

  const handleAceptaCatalogoAge = (idAge, nomAge) => {
    setMostrar4(false);
    txtIdOrg.current.value = idAge;
    txtNombreOrg.current.value = nomAge;
    txtCedula.current.focus();
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar3(true);
    }
  };

  const catalogoAge = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar4(true);
    }
  };

  const blanquear = () => {
    setPassword("");
    setActivate(false);
    setCorreo("");
    setOperacionPer(0);
    setAplicaciones({
      contabilidadpresus: "0",
      administracion: "0",
      ingenieriamun: "0",
      contabilidadfis: "0",
      compraventa: "0",
      bienesmunicipales: "0",
      gestioncontrol: "0",
      rentasmuni: "0",
      catastro: "0",
      nomina: "0",
    });
    setModulos({
      permodtimbre: "0",
      permodminas: "0",
      permod1x500: "0",
      permodprod: "0",
      permodfiscal: "0",
      permodingresos: "0",
      permodpresu: "0",
      permodconfig: "0",
    });
    setPermisos({
      acccontribuyente: "0000",
      accactividad: "0000",
      accdeclaraciones: "000",
      accacticontri: "00",
      accagente: "0000",
      accusuariocome: "0000",
    });

    setItemAccaplicaciones("");
    setItemAccconfigene("");
    setItemAccpersonas("");
    setItemAccusertim("");
    setItemAccuc("");
    setItemAccute("");
    setItemAccporcenute("");
    setItemAccuserweb("");
    setItemAccuserapp("");
    setitemAccestorg("");
  };

  const cancelar = () => {
    blanquear();

    props.onHideCancela();
  };

  const handleChangeOtro = (event) => {
    setAplicaciones({
      ...aplicaciones,
      [event.target.name]: event.target.value === "true" ? "1" : "0",
    });
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputCodigo") {
        txtLogin.current.focus();
      } else if (event.target.id === "inputLogin") {
        txtPassword.current.focus();
      } else if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
          txtPassword.current.focus();
        } else {
          txtConfirmPassword.current.focus();
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
          txtConfirmPassword.current.focus();
        } else {
          txtIdOrg.current.focus();
        }
      } else if (event.target.id === "inputNomUsuario") {
        txtApellidoUsuario.current.focus();
      } else if (event.target.id === "inputApeUsuario") {
        txtDireccionUsuario.current.focus();
      } else if (event.target.id === "inputDireUsuario") {
        txtEmailUsuario.current.focus();
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        txtCelUsuario.current.focus();
      } else if (event.target.id === "inputCelUsuario") {
        txtFechaNac.current.focus();
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        txtCelUsuario.current.focus();
      } else if (event.target.id === "inputCelUsuario") {
        txtFechaNac.current.focus();
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const validarAgente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosAgente(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const datosAgente = (idagente) => {
    let campos = "*";
    let nomtab = "organizacion";
    let nomid = "idorganizacion";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idagente}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtNombreOrg.current.value = response.data.nombre;
            txtIdOrg.current.value = idagente;
          } else {
            txtNombreOrg.current.value = "";
            txtIdOrg.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Agente no existe.",
              icono: "informacion",
            });
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    var sigue = true;
    var mensaje = "";

    if (txtLogin.current.value.trim() === "") {
      mensaje = "El Usuario no debe estar vacio";
      sigue = false;
      setTabIndex(0);
      txtLogin.current.focus();
    } else if (txtPassword.current.value.trim() === "" && operacion === 1) {
      mensaje = "La Contraseña no debe estar vacia";
      sigue = false;
      setTabIndex(0);
      txtPassword.current.focus();
    } else if (
      txtConfirmPassword.current.value.trim() === "" &&
      operacion === 1
    ) {
      mensaje = "La Confirmación de la Contraseña no debe estar vacia";
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (
      txtPassword.current.value.trim() !==
        txtConfirmPassword.current.value.trim() &&
      operacion === 1
    ) {
      mensaje = "Las Contraseñas no coinciden";
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      mensaje = "La cedula no debe estar vacia";
      sigue = false;
      txtCedula.current.focus();
    } else if (txtNombreUsuario.current.value.trim() === "") {
      mensaje = "Los nombres no deben estar vacios";
      sigue = false;
      txtNombreUsuario.current.focus();
    } else if (txtApellidoUsuario.current.value.trim() === "") {
      mensaje = "Los Apellidos no deben estar vacio";
      sigue = false;
      txtApellidoUsuario.current.focus();
    } else if (txtDireccionUsuario.current.value.trim() === "") {
      mensaje = "La direccion del Usuario no debe estar vacia";
      sigue = false;
      txtDireccionUsuario.current.focus();
    } else if (txtFechaNac.current.value.trim() === "") {
      mensaje = "La fecha de nacimiento no debe estar vacia";
      sigue = false;
      txtFechaNac.current.focus();
    }

    if (sigue) {
      let body = {
        operacion: operacion,
        nid:
          txtIdUsuario.current.value === "" ? "0" : txtIdUsuario.current.value,
        logi: txtLogin.current.value,
        pas: txtPassword.current.value,
        ced: txtCedula.current.value,
        idorg: txtIdOrg.current.value,
        perapli:
          aplicaciones.contabilidadpresus +
          aplicaciones.administracion +
          aplicaciones.ingenieriamun +
          aplicaciones.contabilidadfis +
          aplicaciones.compraventa +
          aplicaciones.bienesmunicipales +
          aplicaciones.rentasmuni +
          aplicaciones.catastro +
          aplicaciones.nomina +
          aplicaciones.gestioncontrol ,
        perorg: acciones.org1 + acciones.org2 + acciones.org3 + acciones.org4,
        perestru:
          acciones.estru1 + acciones.estru2 + acciones.estru3 + acciones.estru4,
        perfecha: aplicaciones2.cfecha,
        perusu:
          acciones.user1 + acciones.user2 + acciones.user3 + acciones.user4,
        perperso:
          acciones.person1 +
          acciones.person2 +
          acciones.person3 +
          acciones.person4,
        periva: aplicaciones2.iva,
        perut: aplicaciones2.ut,
        perefi: aplicaciones2.cefiscal,
        perdesc: props.usuario
          ? props.usuario.accdesconectar !== ""
            ? props.usuario.accdesconectar
            : "0"
          : "0",
        perdesb: props.usuario
          ? props.usuario.accdesbloquear !== ""
            ? props.usuario.accdesbloquear
            : "0"
          : "0",
        peract: aplicaciones2.ta,
        perpas: aplicaciones2.tp,
        perbit: props.usuario
          ? props.usuario.accrepbit !== ""
            ? props.usuario.accrepbit
            : "0"
          : "0",
        operacionper: operacionPer,
        cor: txtEmailUsuario.current.value,
        ctlf1: txtTlfUsuario.current.value,
        ctlf2: txtCelUsuario.current.value,
        ape: txtApellidoUsuario.current.value.toUpperCase(),
        dir: txtDireccionUsuario.current.value.toUpperCase(),
        fnac: txtFechaNac.current.value,
        nac: cmbNacionalidad.current.value,
        nombres: txtNombreUsuario.current.value.toUpperCase(),
        sex: cmbSexo.current.value,
        estatus: cmbStatus.current.checked ? "1" : "0",
      };
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
      setBody(body);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: mensaje,
        icono: "informacion",
      });
    }
  };

  const onChange = (e) => {
    if (e.target.id === "modulo") {
      setAplicaciones2({ ...aplicaciones2, [e.target.name]: e.target.value });
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setActivate(true);
    procesarRegistro();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideAcepta();
  };

  const mostrarPassword = () => setMostrarClave(!mostrarClave);
  const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);

  const checkTodo = (event) => {
    /* if (event.target.name === "organizacion") {
      if (chkOrgTodo.current.checked) {
        setAcciones({
          ...acciones,
          org1: "1",
          org2: "1",
          org3: "1",
          org4: "1",
        });
      } else {
        setAcciones({
          ...acciones,
          org1: "0",
          org2: "0",
          org3: "0",
          org4: "0",
        });
      }
    } else */ if (event.target.name === "personas") {
      if (chkPerTodo.current.checked) {
        setAcciones({
          ...acciones,
          person1: "1",
          person2: "1",
          person3: "1",
          person4: "1",
        });
      } else {
        setAcciones({
          ...acciones,
          person1: "0",
          person2: "0",
          person3: "0",
          person4: "0",
        });
      }
    } else if (event.target.name === "estructura") {
      if (chkEsOrTodo.current.checked) {
        setAcciones({
          ...acciones,
          estru1: "1",
          estru2: "1",
          estru3: "1",
          estru4: "1",
        });
      } else {
        setAcciones({
          ...acciones,
          estru1: "0",
          estru2: "0",
          estru3: "0",
          estru4: "0",
        });
      }
    } else if (event.target.name === "usuarios") {
      if (chkUserTodo.current.checked) {
        setAcciones({
          ...acciones,
          user1: "1",
          user2: "1",
          user3: "1",
          user4: "1",
        });
      } else {
        setAcciones({
          ...acciones,
          user1: "0",
          user2: "0",
          user3: "0",
          user4: "0",
        });
      }
    }
  };

  const checkBlank = (e) => {
    if (acciones[e.target.id] === "0") {
      setAcciones({ ...acciones, [e.target.id]: "1" });
    } else {
      setAcciones({ ...acciones, [e.target.id]: "0" });
    }

    if (
      chkPerCon.current.checked &&
      chkPerIn.current.checked &&
      chkPerMod.current.checked &&
      chkPerEli.current.checked
    ) {
      chkPerTodo.current.checked = true;
    } else {
      chkPerTodo.current.checked = false;
    }

    /* if (
      chkOrgCon.current.checked &&
      chkOrgIn.current.checked &&
      chkOrgMod.current.checked &&
      chkOrgEli.current.checked
    ) {
      chkOrgTodo.current.checked = true;
    } else {
      chkOrgTodo.current.checked = false;
    } */

    if (
      chkEsOrCon.current.checked &&
      chkEsOrIn.current.checked &&
      chkEsOrMod.current.checked &&
      chkEsOrEli.current.checked
    ) {
      chkEsOrTodo.current.checked = true;
    } else {
      chkEsOrTodo.current.checked = false;
    }

    if (
      chkUserCon.current.checked &&
      chkUserIn.current.checked &&
      chkUserMod.current.checked &&
      chkUserEli.current.checked
    ) {
      chkUserTodo.current.checked = true;
    } else {
      chkUserTodo.current.checked = false;
    }
  };

  const validarCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer,
  ) => {
    setMostrarPersona(false);

    datosRes(cedPer);
  };

  const validarCatalogoOrg = (idOrga, nomOrga, razosocOrga) => {
    setMostrarOrg(false);
    datosAgente(idOrga);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setDeshabilitado(props.deshabilitado);
        console.log(props.usuario);
        setTabIndex(0);
        setTabIndex1(0);
        if (props.operacion !== 1) {
          setOperacionPer(0);
          if (props.usuario.idorganizacion !== "") {
            datosAgente(props.usuario.idorganizacion);
          }

          setAplicaciones({
            contabilidadpresus:
              props.usuario.accaplicacion === ""
                ? "0"
                : props.usuario.accaplicacion.substring(0, 1),
            administracion:
              props.usuario.accaplicacion === ""
                ? "0"
                : props.usuario.accaplicacion.substring(1, 2),
            ingenieriamun:
              props.usuario.accaplicacion === ""
                ? "0"
                : props.usuario.accaplicacion.substring(2, 3),
            contabilidadfis:
              props.usuario.accaplicacion === ""
                ? "0"
                : props.usuario.accaplicacion.substring(3, 4),
            compraventa:
              props.usuario.accaplicacion === ""
                ? "0"
                : props.usuario.accaplicacion.substring(4, 5),
            bienesmunicipales:
              props.usuario.accaplicacion === ""
                ? "0"
                : props.usuario.accaplicacion.substring(5, 6),
            rentasmuni:
              props.usuario.accaplicacion === ""
                ? "0"
                : props.usuario.accaplicacion.substring(6, 7),
            catastro:
              props.usuario.accaplicacion === ""
                ? "0"
                : props.usuario.accaplicacion.substring(7, 8),
            nomina:
              props.usuario.accaplicacion === ""
                ? "0"
                : props.usuario.accaplicacion.substring(8, 9),
            gestioncontrol:
              props.usuario.accaplicacion === ""
                ? "0"
                : props.usuario.accaplicacion.substring(9, 10),
          });
          setAplicaciones2({
            iva:
              props.usuario.acciva === "" ? "0" : props.usuario.acciva.trim(),
            ut: props.usuario.accut === "" ? "0" : props.usuario.accut,
            ta:
              props.usuario.acctasaactiva === ""
                ? "0"
                : props.usuario.acctasaactiva,
            tp:
              props.usuario.acctasapasiva === ""
                ? "0"
                : props.usuario.acctasapasiva,
            cfecha:
              props.usuario.acccambiofecha === ""
                ? "0"
                : props.usuario.acccambiofecha,
            cefiscal:
              props.usuario.acccambioefiscal === ""
                ? "0"
                : props.usuario.acccambioefiscal,
          });
          console.log("este es el iva" + props.usuario.acciva);
          setAcciones({
            org1:
              props.usuario.accorganizacion === ""
                ? "0"
                : props.usuario.accorganizacion.substring(0, 1),
            org2:
              props.usuario.accorganizacion === ""
                ? "0"
                : props.usuario.accorganizacion.substring(1, 2),
            org3:
              props.usuario.accorganizacion === ""
                ? "0"
                : props.usuario.accorganizacion.substring(2, 3),
            org4:
              props.usuario.accorganizacion === ""
                ? "0"
                : props.usuario.accorganizacion.substring(3, 4),
            estru1:
              props.usuario.accestructura === ""
                ? "0"
                : props.usuario.accestructura.substring(0, 1),
            estru2:
              props.usuario.accestructura === ""
                ? "0"
                : props.usuario.accestructura.substring(1, 2),
            estru3:
              props.usuario.accestructura === ""
                ? "0"
                : props.usuario.accestructura.substring(2, 3),
            estru4:
              props.usuario.accestructura === ""
                ? "0"
                : props.usuario.accestructura.substring(3, 4),
            user1:
              props.usuario.accusuario === ""
                ? "0"
                : props.usuario.accusuario.substring(0, 1),
            user2:
              props.usuario.accusuario === ""
                ? "0"
                : props.usuario.accusuario.substring(1, 2),
            user3:
              props.usuario.accusuario === ""
                ? "0"
                : props.usuario.accusuario.substring(2, 3),
            user4:
              props.usuario.accusuario === ""
                ? "0"
                : props.usuario.accusuario.substring(3, 4),
            person1:
              props.usuario.accpersona === ""
                ? "0"
                : props.usuario.accpersona.substring(0, 1),
            person2:
              props.usuario.accpersona === ""
                ? "0"
                : props.usuario.accpersona.substring(1, 2),
            person3:
              props.usuario.accpersona === ""
                ? "0"
                : props.usuario.accpersona.substring(2, 3),
            person4:
              props.usuario.accpersona === ""
                ? "0"
                : props.usuario.accpersona.substring(3, 4),
          });
        } else {
        }
      }}
    >
      <Modal.Header className="azulGradiant">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Registrar Usuario"
              : operacion === 2
                ? "Modificar Usurario"
                : operacion === 3
                  ? "Eliminar Usuario"
                  : "Consultar Usuario"}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflow: "scroll" }}>
        <CatalogoPersona
          show={mostrarPersona}
          onHideAceptaCatPer={validarCatalogoPer}
          onHideCancelaCatPer={() => {
            setMostrarPersona(false);
          }}
        />

        <CatalogoOrganizacion
          show={mostrarOrg}
          onHideCancelaCatOrg={() => {
            setMostrarOrg(false);
          }}
          onHideAceptaCatOrg={validarCatalogoOrg}
        />
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="">
          <div>
            <ul className="nav" id="ex-with-icons" role="tablist">
              <li className="nav-item" role="presentation">
                <a
                  key={"tab-1"}
                  className=" rounded nav-link active bg-blue-100 text-light"
                  id="tab-1-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#tab-1"
                  type="button"
                  role="tab"
                  aria-controls="tab-1"
                  aria-selected="true"
                >
                  <i className="fas fa-user-edit fa-fw me-2"></i>Usuario
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  key={"tab-2"}
                  className=" rounded nav-link bg-blue-100 text-light"
                  id="tab-2-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#tab-2"
                  type="button"
                  role="tab"
                  aria-controls="tab-2"
                  aria-selected="true"
                >
                  <i className="fas fa-vote-yea fa-fw me-2"></i>Permisos
                  Aplicaciones
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  key={"tab-3"}
                  className=" rounded nav-link bg-blue-100 text-light"
                  id="tab-3-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#tab-3"
                  type="button"
                  role="tab"
                  aria-controls="tab-3"
                  aria-selected="true"
                >
                  <i className="fas fa-vote-yea fa-fw me-2"></i>Permisos
                  Configuracion{" "}
                </a>
              </li>
            </ul>
            <div className="tab-content" id="ex-with-icons-content">
              <div
                className="tab-pane fade show active"
                id="tab-1"
                role="tabpanel"
                aria-labelledby="tab-1"
              >
                <div className="container-fluid row  justify-content-between h-100 py-2 px-0  mx-auto">
                  <div className="input-group mb-2 input-group-sm col-sm-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="far fa-lg px-1 fa-id-card"></i>Codigo:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      ref={txtIdUsuario}
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        props.usuario ? props.usuario.idusuario : ""
                      }
                      id="inputCodigo"
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group mb-2 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-file-signature"></i>Nom.
                      Usuario:
                    </label>
                    <input
                      type="text"
                      autocomplete="off"
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtLogin}
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={props.usuario ? props.usuario.login : ""}
                      id="inputLogin"
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group mb-2 input-group-sm col-sm-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      {" "}
                      Estatus
                    </label>
                    <select
                      ref={cmbStatus}
                      disabled={
                        operacion !== 4 || operacion === 3 ? false : true
                      }
                      className="form-select"
                      aria-label="Default select example"
                      defaultValue={props.usuario ? props.usuario.status : ""}
                    >
                      <option value="1">Activo</option>
                      <option value="2">Inactivo</option>
                    </select>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-unlock-alt"></i>
                      Contraseña:
                    </label>
                    <input
                      type={mostrarClave ? "text" : "password"}
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtPassword}
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputPassword"
                      onKeyUp={handleInputChange}
                    />
                    <button
                      style={{ textAlign: "center", color: "white" }}
                      disabled={operacion === 2 ? true : deshabilitado}
                      onClick={mostrarPassword}
                      className="btn btn-sm btn-info"
                    >
                      <i className="fa fa-eye-slash"></i>{" "}
                    </button>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-unlock-alt"></i>Confir.
                      Contr.:
                    </label>
                    <input
                      type={mostrarClave1 ? "text" : "password"}
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtConfirmPassword}
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputConfirmPassword"
                      onKeyUp={handleInputChange}
                    />
                    <button
                      style={{ textAlign: "center", color: "white" }}
                      disabled={operacion === 2 ? true : deshabilitado}
                      onClick={mostrarPassword1}
                      className="btn btn-sm btn-info"
                    >
                      <i className="fa fa-eye-slash"></i>{" "}
                    </button>
                  </div>

                  <fieldset className="row border-azul rounded mx-auto">
                    <legend className="float-none m-0 w-auto">
                      Organización
                    </legend>

                    <div className="input-group my-auto input-group-sm col-sm-12">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="far fa-lg px-1 fa-id-card"></i>Código:
                      </label>
                      <input
                        type="text"
                        ref={txtIdOrg}
                        disabled={
                          operacion !== 4 || operacion === 3 ? false : true
                        }
                        autoComplete="off"
                        className="form-control col-md-1"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputIdAgente"
                        defaultValue={
                          props.usuario ? props.usuario.idagente : ""
                        }
                        onKeyUp={validarAgente}
                        onBlur={validarAgente}
                      />
                      <button
                        onClick={() => {
                          setMostrarOrg(true);
                        }}
                        className="btn btn-sm  btn-success"
                      >
                        <i className="fa fa-search"></i>{" "}
                      </button>
                      <input
                        type="text"
                        disabled={true}
                        ref={txtNombreOrg}
                        autoComplete="off"
                        className="form-control text-uppercase"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputNomUsuario" /* defaultValue={props.usuario ? props.usuario.nombreagente.trim() : ''} */
                      />
                    </div>
                  </fieldset>

                  <fieldset className="row border-azul rounded mx-auto mt-2">
                    <legend className="float-none m-0 w-auto">
                      Datos Personales del Usuario
                    </legend>

                    <div className="input-group mb-2 input-group-sm col-md-4">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="far fa-lg fa-id-card"></i>Cedula:
                      </label>
                      <input
                        type="text"
                        ref={txtCedula}
                        autoComplete="off"
                        disabled={
                          operacion !== 4 || operacion === 3 ? false : true
                        }
                        className="form-control text-uppercase"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputCedula"
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.cedula
                            : ""
                        }
                        onKeyUp={validarPersona}
                        onBlur={validarPersona}
                      />
                      <button
                        onClick={() => {
                          setMostrarPersona(true);
                        }}
                        className="btn btn-sm  btn-success"
                      >
                        <i className="fa fa-search"></i>{" "}
                      </button>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="input-group mb-2 input-group-sm col-md-4 ">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-map-marked-alt"></i>
                        Nacionalidad:
                      </label>
                      <select
                        disabled={!habilitadoNU}
                        ref={cmbNacionalidad}
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.nacionalidad
                            : ""
                        }
                        className="form-select"
                        aria-label="Default select example "
                      >
                        <option key="0" value="V">
                          V
                        </option>
                        <option key="1" value="E">
                          E
                        </option>
                      </select>
                    </div>
                    <div className="input-group mb-2 input-group-sm col-md-3">
                      <label
                        className="input-group-text ml-2"
                        id="inputGroup-sizing-sm"
                      >
                        Sexo:
                      </label>
                      <select
                        disabled={!habilitadoNU}
                        ref={cmbSexo}
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.sexo
                            : ""
                        }
                        className="form-select"
                        aria-label="Default select example"
                      >
                        <option key="0" value="M">
                          M
                        </option>
                        <option key="1" value="F">
                          F
                        </option>
                      </select>
                    </div>

                    <div className="input-group mb-2 input-group-sm col-sm-6 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-file-signature"></i>
                        Nombres:
                      </label>
                      <input
                        type="text"
                        disabled={!habilitadoNU}
                        autoComplete="off"
                        ref={txtNombreUsuario}
                        className="form-control text-uppercase"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputNomUsuario"
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.nombres.trim()
                            : ""
                        }
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>
                    <div className="input-group mb-2 input-group-sm col-sm-6 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-file-signature"></i>
                        apellidos:
                      </label>
                      <input
                        type="text"
                        disabled={!habilitadoNU}
                        autoComplete="off"
                        ref={txtApellidoUsuario}
                        className="form-control text-uppercase"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputApeUsuario"
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.apellidos.trim()
                            : ""
                        }
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>
                    <div className="input-group mb-2 input-group-sm col-sm-12 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-file-signature"></i>
                        Direccion:
                      </label>
                      <input
                        type="text"
                        disabled={!habilitadoNU}
                        autoComplete="off"
                        ref={txtDireccionUsuario}
                        className="form-control text-uppercase"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputApeUsuario"
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.direccion.trim()
                            : ""
                        }
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>

                    <div className="input-group mb-2 input-group-sm col-sm-4 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="far fa-lg px-1 fa-calendar-alt"></i>Fecha
                        Nacimiento:
                      </label>
                      <input
                        type="date"
                        disabled={!habilitadoNU}
                        ref={txtFechaNac}
                        className="form-control px-0"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputFechaNac"
                        max={moment.utc(fechaSistema).format("YYYY-MM-DD")}
                        defaultValue={
                          props.datospersonales
                            ? moment
                                .utc(props.datospersonales.fnacimiento)
                                .format("YYYY-MM-DD")
                            : ""
                        }
                        onKeyUp={handleInputChange}
                      />
                    </div>

                    <div className="input-group mb-2 input-group-sm col-sm-4">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-phone"></i>Telefono:
                      </label>
                      <input
                        type="text"
                        disabled={!habilitadoNU}
                        autoComplete="off"
                        ref={txtTlfUsuario}
                        className="form-control text-uppercase"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputTlfUsuario"
                        placeholder="0000-0000000"
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.tlf1 !== null
                              ? props.datospersonales.tlf1.trim()
                              : ""
                            : ""
                        }
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>

                    <div className="input-group mb-2 input-group-sm col-sm-4 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-mobile-alt"></i>Celular:
                      </label>
                      <input
                        type="text"
                        disabled={!habilitadoNU}
                        autoComplete="off"
                        ref={txtCelUsuario}
                        className="form-control text-uppercase"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputCelUsuario"
                        placeholder="0000-0000000"
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.tlf2 !== null
                              ? props.datospersonales.tlf2.trim()
                              : ""
                            : ""
                        }
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>
                    <div className="input-group mb-2 input-group-sm col-sm-12 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        {" "}
                        <i className="fas fa-lg px-1 fa-at"></i>E-mail:
                      </label>
                      <input
                        type="text"
                        disabled={!habilitadoNU}
                        autoComplete="off"
                        ref={txtEmailUsuario}
                        className="form-control text-uppercase"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputEmailUsuario"
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.correoe !== null
                              ? props.datospersonales.correoe.trim()
                              : ""
                            : ""
                        }
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>
                  </fieldset>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="tab-2"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-2"
              >
                <div className="container-fluid row  justify-content-between h-100 py-2 px-4  mx-auto">
                  <div className="border col-sm-12 py-3 mb-2 border d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5">
                        {" "}
                        Contabilidad Presupuestaria
                      </div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="contabilidadpresus"
                          id="inlineRadio1"
                          value={true}
                          checked={aplicaciones.contabilidadpresus === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="contabilidadpresus"
                          id="inlineRadio2"
                          value={false}
                          checked={aplicaciones.contabilidadpresus === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>
                      <div />
                    </div>
                  </div>
                  <div className="border col-sm-12 py-3 mb-2 border d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5">
                        {" "}
                        Administración y Tesoreria
                      </div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="administracion"
                          id="inlineRadio3"
                          value={true}
                          checked={aplicaciones.administracion === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio3">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="administracion"
                          id="inlineRadio4"
                          value={false}
                          checked={aplicaciones.administracion === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio4">
                          No Disponible
                        </label>
                      </div>
                      <div />
                    </div>
                  </div>
                  <div className="border col-sm-12 py-3 mb-2 border d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Ingeniería Municipal</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="ingenieriamun"
                          id="inlineRadio5"
                          value={true}
                          checked={aplicaciones.ingenieriamun === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio5">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="ingenieriamun"
                          id="inlineRadio6"
                          value={false}
                          checked={aplicaciones.ingenieriamun === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio6">
                          No Disponible
                        </label>
                      </div>
                      <div />
                    </div>
                  </div>
                  <div className="border col-sm-12 py-3 mb-2 border d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Contabilidad Físcal</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="contabilidadfis"
                          id="inlineRadio7"
                          value={true}
                          checked={aplicaciones.contabilidadfis === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio7">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="contabilidadfis"
                          id="inlineRadio8"
                          value={false}
                          checked={aplicaciones.contabilidadfis === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio8">
                          No Disponible
                        </label>
                      </div>
                      <div />
                    </div>
                  </div>
                  <div className="border col-sm-12 py-3 mb-2 border d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Compra y Almacén</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="compraventa"
                          id="inlineRadio9"
                          value={true}
                          checked={aplicaciones.compraventa === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio9">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="compraventa"
                          id="inlineRadio10"
                          value={false}
                          checked={aplicaciones.compraventa === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio10">
                          No Disponible
                        </label>
                      </div>
                      <div />
                    </div>
                  </div>
                  <div className="border col-sm-12 py-3 mb-2 border d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Bienes Municipales</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="bienesmunicipales"
                          id="inlineRadio11"
                          value={true}
                          checked={aplicaciones.bienesmunicipales === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio11">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="bienesmunicipales"
                          id="inlineRadio12"
                          value={false}
                          checked={aplicaciones.bienesmunicipales === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio12">
                          No Disponible
                        </label>
                      </div>
                      <div />
                    </div>
                  </div>
                  <div className="border col-sm-12 py-3 mb-2 border d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Gestion y Control</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="gestioncontrol"
                          id="inlineRadio13"
                          value={true}
                          checked={aplicaciones.gestioncontrol === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio13">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="gestioncontrol"
                          id="inlineRadio14"
                          value={false}
                          checked={aplicaciones.gestioncontrol === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio14">
                          No Disponible
                        </label>
                      </div>
                      <div />
                    </div>
                  </div>
                  <div className="border col-sm-12 py-3 mb-2 border d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Rentas Municipales</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="rentasmuni"
                          id="inlineRadio15"
                          value={true}
                          checked={aplicaciones.rentasmuni === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio15">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="rentasmuni"
                          id="inlineRadio16"
                          value={false}
                          checked={aplicaciones.rentasmuni === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio16">
                          No Disponible
                        </label>
                      </div>
                      <div />
                    </div>
                  </div>
                  <div className="border col-sm-12 py-3 mb-2 border d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Catastro</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="catastro"
                          id="inlineRadio17"
                          value={true}
                          checked={aplicaciones.catastro === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio17">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="catastro"
                          id="inlineRadio18"
                          value={false}
                          checked={aplicaciones.catastro === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio18">
                          No Disponible
                        </label>
                      </div>
                      <div />
                    </div>
                  </div>

                  <div className="border col-sm-12 py-3 mb-2 border d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Nómina</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="nomina"
                          id="inlineRadio19"
                          value={true}
                          checked={aplicaciones.nomina === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio19">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="nomina"
                          id="inlineRadio20"
                          value={false}
                          checked={aplicaciones.nomina === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio20">
                          No Disponible
                        </label>
                      </div>
                      <div />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="tab-3"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-3"
              >
                <div className="row mx-auto">
                  {/* Organización */}
                  <div className="col-md-12 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend className="float-none w-auto">
                        Organización
                      </legend>

                      <div className="col-md-12 row mb-3 rounded mx-auto">
                        {/* <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              name="org"
                              id="org1"
                              onChange={checkBlank}
                              ref={chkOrgCon}
                              checked={acciones.org1 === "1" ? true : false}
                            />
                            <label className="form-check-label py-1" for="org1">
                              Consultar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              name="org"
                              id="org2"
                              onChange={checkBlank}
                              ref={chkOrgIn}
                              checked={acciones.org2 === "1" ? true : false}
                            />
                            <label className="form-check-label py-1" for="org2">
                              Incluir
                            </label>
                          </div>
                        </div> */}
                        <div className="col d-flex ">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              name="org"
                              id="org3"
                              onChange={checkBlank}
                              ref={chkOrgMod}
                              checked={acciones.org3 === "1" ? true : false}
                            />
                            <label className="form-check-label py-1" for="org3">
                              Modificar
                            </label>
                          </div>
                        </div>
                        {/* <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              name="org"
                              id="org4"
                              onChange={checkBlank}
                              ref={chkOrgEli}
                              checked={acciones.org4 === "1" ? true : false}
                            />
                            <label className="form-check-label py-1" for="org4">
                              Eliminar
                            </label>
                          </div>
                        </div> 
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="todoorg"
                              name="organizacion"
                              ref={chkOrgTodo}
                              checked={
                                acciones.org1 === "1" &&
                                acciones.org2 === "1" &&
                                acciones.org3 === "1" &&
                                acciones.org4 === "1"
                                  ? true
                                  : false
                              }
                              onChange={checkTodo}
                            />
                            <label
                              className="form-check-label py-1"
                              for="todoorg"
                            >
                              Todo
                            </label>
                          </div>
                        </div>*/}
                      </div>
                    </fieldset>
                  </div>

                  {/* Persona */}
                  <div className="col-md-12 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend className="float-none w-auto">Persona</legend>

                      <div className="col-md-12 row mb-3 rounded mx-auto">
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="person1"
                              onChange={checkBlank}
                              ref={chkPerCon}
                              checked={acciones.person1 === "1" ? true : false}
                            />
                            <label
                              className="form-check-label py-1"
                              for="person1"
                            >
                              Consultar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="person2"
                              onChange={checkBlank}
                              ref={chkPerIn}
                              checked={acciones.person2 === "1" ? true : false}
                            />
                            <label
                              className="form-check-label py-1"
                              for="person2"
                            >
                              Incluir
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="person3"
                              onChange={checkBlank}
                              ref={chkPerMod}
                              checked={acciones.person3 === "1" ? true : false}
                            />
                            <label
                              className="form-check-label py-1"
                              for="person3"
                            >
                              Modificar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="person4"
                              onChange={checkBlank}
                              ref={chkPerEli}
                              checked={acciones.person4 === "1" ? true : false}
                            />
                            <label
                              className="form-check-label py-1"
                              for="person4"
                            >
                              Eliminar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="todoperson"
                              name="personas"
                              ref={chkPerTodo}
                              checked={
                                acciones.person1 === "1" &&
                                acciones.person2 === "1" &&
                                acciones.person3 === "1" &&
                                acciones.person4 === "1"
                                  ? true
                                  : false
                              }
                              onChange={checkTodo}
                            />
                            <label
                              className="form-check-label py-1"
                              for="todoperson"
                            >
                              Todo
                            </label>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  {/* Estructura Organizativa */}
                  <div className="col-md-12 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend className="float-none w-auto">
                        Estructura Organizativa
                      </legend>

                      <div className="col-md-12 row mb-3 rounded mx-auto">
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="estru1"
                              onChange={checkBlank}
                              ref={chkEsOrCon}
                              checked={acciones.estru1 === "1" ? true : false}
                            />
                            <label
                              className="form-check-label py-1"
                              for="estru1"
                            >
                              Consultar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="estru2"
                              onChange={checkBlank}
                              ref={chkEsOrIn}
                              checked={acciones.estru2 === "1" ? true : false}
                            />
                            <label
                              className="form-check-label py-1"
                              for="estru2"
                            >
                              Incluir
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="estru3"
                              onChange={checkBlank}
                              ref={chkEsOrMod}
                              checked={acciones.estru3 === "1" ? true : false}
                            />
                            <label
                              className="form-check-label py-1"
                              for="estru3"
                            >
                              Modificar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="estru4"
                              onChange={checkBlank}
                              ref={chkEsOrEli}
                              checked={acciones.estru4 === "1" ? true : false}
                            />
                            <label
                              className="form-check-label py-1"
                              for="estru4"
                            >
                              Eliminar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="todoest"
                              name="estructura"
                              ref={chkEsOrTodo}
                              checked={
                                acciones.estru1 === "1" &&
                                acciones.estru2 === "1" &&
                                acciones.estru3 === "1" &&
                                acciones.estru4 === "1"
                                  ? true
                                  : false
                              }
                              onChange={checkTodo}
                            />
                            <label
                              className="form-check-label py-1"
                              for="todoest"
                            >
                              Todo
                            </label>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  {/* Usuarios */}
                  <div className="col-md-12 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend className="float-none w-auto">Usuarios</legend>

                      <div className="col-md-12 row mb-3 rounded mx-auto">
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="user1"
                              onChange={checkBlank}
                              ref={chkUserCon}
                              checked={acciones.user1 === "1" ? true : false}
                            />
                            <label
                              className="form-check-label py-1"
                              for="user1"
                            >
                              Consultar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="user2"
                              onChange={checkBlank}
                              ref={chkUserIn}
                              checked={acciones.user2 === "1" ? true : false}
                            />
                            <label
                              className="form-check-label py-1"
                              for="user2"
                            >
                              Incluir
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="user3"
                              onChange={checkBlank}
                              ref={chkUserMod}
                              checked={acciones.user3 === "1" ? true : false}
                            />
                            <label
                              className="form-check-label py-1"
                              for="user3"
                            >
                              Modificar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="user4"
                              onChange={checkBlank}
                              ref={chkUserEli}
                              checked={acciones.user4 === "1" ? true : false}
                            />
                            <label
                              className="form-check-label py-1"
                              for="user4"
                            >
                              Eliminar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="todousuario"
                              name="usuarios"
                              ref={chkUserTodo}
                              checked={
                                acciones.user1 === "1" &&
                                acciones.user2 === "1" &&
                                acciones.user3 === "1" &&
                                acciones.user4 === "1"
                                  ? true
                                  : false
                              }
                              onChange={checkTodo}
                            />
                            <label
                              className="form-check-label py-1"
                              for="todousuario"
                            >
                              Todo
                            </label>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  {/* VAlor iva */}
                  <div className="col-md-6 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend className="float-none w-auto">Valor % IVA</legend>
                      <div className="col-md-6 pl-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="iva"
                            value={"1"}
                            id="modulo"
                            onChange={onChange}
                            checked={aplicaciones2.iva === "1" ? true : false}
                          />
                          <label className="form-check-label py-1">
                            Disponible
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="iva"
                            value={"0"}
                            id="modulo"
                            onChange={onChange}
                            checked={aplicaciones2.iva === "0" ? true : false}
                          />
                          <label className="form-check-label py-1">
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  {/* vut */}
                  <div className="col-md-6 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend className="float-none w-auto">
                        Valor Unidad Tributaria
                      </legend>
                      <div className="col-md-6 pl-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="ut"
                            value={"1"}
                            id="modulo"
                            onChange={onChange}
                            checked={aplicaciones2.ut === "1" ? true : false}
                          />
                          <label className="form-check-label py-1">
                            Disponible
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="ut"
                            value={"0"}
                            id="modulo"
                            onChange={onChange}
                            checked={aplicaciones2.ut === "0" ? true : false}
                          />
                          <label className="form-check-label py-1">
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  {/* Tasa Activa */}
                  <div className="col-md-6 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend className="float-none w-auto">Tasa Activa</legend>
                      <div className="col-md-6 pl-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="ta"
                            value={"1"}
                            id="modulo"
                            onChange={onChange}
                            checked={aplicaciones2.ta === "1" ? true : false}
                          />
                          <label className="form-check-label py-1">
                            Disponible
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="ta"
                            value={"0"}
                            id="modulo"
                            onChange={onChange}
                            checked={aplicaciones2.ta === "0" ? true : false}
                          />
                          <label className="form-check-label py-1">
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  {/* Tasa Pasiva */}
                  <div className="col-md-6 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend className="float-none w-auto">Tasa Pasiva</legend>
                      <div className="col-md-6 pl-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="tp"
                            value={"1"}
                            id="modulo"
                            onChange={onChange}
                            checked={aplicaciones2.tp === "1" ? true : false}
                          />
                          <label className="form-check-label py-1">
                            Disponible
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="tp"
                            value={"0"}
                            id="modulo"
                            onChange={onChange}
                            checked={aplicaciones2.tp === "0" ? true : false}
                          />
                          <label className="form-check-label py-1">
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  {/* Cambiar Fecha del Sistema */}
                  <div className="col-md-6 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend className="float-none w-auto">
                        Cambiar Fecha del Sistema
                      </legend>
                      <div className="col-md-6 pl-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="cfecha"
                            value={"1"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              aplicaciones2.cfecha === "1" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            Disponible
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="cfecha"
                            value={"0"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              aplicaciones2.cfecha === "0" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  {/* Cambiar Ejercicio Fiscal */}
                  <div className="col-md-6 row mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                      <legend className="float-none w-auto">
                        Cambiar Ejercicio Fiscal
                      </legend>
                      <div className="col-md-6 pl-3 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="cefiscal"
                            value={"1"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              aplicaciones2.cefiscal === "1" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            Disponible
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            type="radio"
                            name="cefiscal"
                            value={"0"}
                            id="modulo"
                            onChange={onChange}
                            checked={
                              aplicaciones2.cefiscal === "0" ? true : false
                            }
                          />
                          <label className="form-check-label py-1">
                            No Disponible
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-sm-12 d-flex justify-content-end row mx-auto py-1">
          <button
            type="button"
            ref={btnAcepta}
            disabled={operacion === 4 ? true : false}
            onClick={onChangeValidar}
            style={{ margin: "1px" }}
            className="col-sm-2 btn-sm btn btn-success rounded-pill"
          >
            <i className="far fa-check-circle"></i>Aceptar
          </button>
          <button
            type="button"
            ref={btnCancela}
            onClick={cancelar}
            style={{ margin: "1px" }}
            className="col-sm-2 btn-sm btn btn-danger rounded-pill"
          >
            <i className="fas fa-window-close"></i>Cancelar
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ModalActualizarUsuario;
